import React from 'react';
import { CountryProvider } from 'common/src/contexts/CountryContext';
import { DrawerProvider } from 'common/src/contexts/DrawerContext';

interface AppProvidersProps {
  children: React.ReactNode;
}

const AppProviders = ({ children }: AppProvidersProps) => (
  <CountryProvider>
    <DrawerProvider>{children}</DrawerProvider>
  </CountryProvider>
);

export default AppProviders;
